import {
	ContactFilterField,
	ContactFilterValue,
	ContactsAdvancedFilter,
} from "@/repository/models";

export type AdvancedFilterFieldKey = keyof ContactsAdvancedFilter;

export interface AdvancedFilterFieldDefinition {
	key: AdvancedFilterFieldKey;
	field: ContactFilterField;
	labelId: string;
}

export const advancedFilterFields: AdvancedFilterFieldDefinition[] = [
	{
		key: "jobTitles",
		field: ContactFilterField.JobTitle,
		labelId: "Contacts.Form.JobTitle",
	},
	{
		key: "departments",
		field: ContactFilterField.Department,
		labelId: "Contacts.Form.Department",
	},
	{
		key: "cities",
		field: ContactFilterField.City,
		labelId: "Contacts.Form.City",
	},
	{
		key: "companyNames",
		field: ContactFilterField.CompanyName,
		labelId: "Contacts.Form.CompanyName",
	},
	{
		key: "offices",
		field: ContactFilterField.Office,
		labelId: "Contacts.Form.Office",
	},
	{
		key: "countries",
		field: ContactFilterField.Country,
		labelId: "Contacts.Form.Country",
	},
];

export interface AdvancedFilterButtonProps {
	count: number;
	onClick: () => void;
}

export interface AdvancedFilterFieldProps {
	field: ContactFilterField;
	label: string;
	selected: ContactFilterValue[];
	onChange: (values: ContactFilterValue[]) => void;
	/** Enter with no value left to take, which is the dialog's cue to apply. */
	onEnter?: () => void;
}

export interface AdvancedFilterDialogProps {
	open: boolean;
	setOpen: (open: boolean) => void;
	value: ContactsAdvancedFilter;
	onApply: (value: ContactsAdvancedFilter) => void;
}

export interface ActiveFilterChipsProps {
	value: ContactsAdvancedFilter;
	onRemove: (key: AdvancedFilterFieldKey, value: string) => void;
	onClearAll: () => void;
}
